/**
 * Enumération des types de service d'envoi de mails
 */
export enum TypeService {
    SMTP = 'SMTP',
    API = 'API'
}

/**
 * Enumération des types de chiffrement
 */
export enum TypeCryptage {
    NONE = 'NONE',
    STARTTLS = 'STARTTLS',
    TLS_SSL = 'TLS_SSL'
}

/**
 * Modèle de la configuration SMTP / API pour l'envoi de mails
 */
export class ConfigSMTP {
    /** Identifiant de la configuration */
    idConfig: number;

    /** Type de service utilisé */
    typeService: TypeService;

    /** Adresse du serveur SMTP */
    adresse: string;

    /** Port du serveur SMTP */
    port: number;

    /** Type de chiffrement */
    typeCryptage: TypeCryptage;

    /** Authentification activée */
    authentification: boolean;

    /** Identifiant de connexion */
    identifiant: string;

    /** Mot de passe de connexion */
    motDePasse: string;

    /** Identifiant de la clé API */
    apiKeyId: string;

    /** Clé API */
    apiKey: string;

    /** Notifications par mail activées */
    notification: boolean;

    /** Présélection des destinataires workflow */
    preselectionDestinataire: boolean;

    /** E-mail émetteur */
    mailEmetteur: string;

    /** E-mail de réponse */
    mailReplyTo: string;

    /** E-mail administrateur */
    mailAdmin: string;

    /** E-mail licence */
    mailLicence: string;

    /** Indique si la conf API a été surchargée en base */
    apiConfOverridden: boolean;
}